import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { getThemeValueByKey } from '@statsbomb/kitbag-themes';
import { SURFACE_COLOUR_VARIANTS } from '../../constants/variants.js';
import { getMenuBackgroundColour, applyPositioning, getMenuOpacity, getMenuItemBackgroundColour, getMenuItemTextColour, getActiveOverlayBackgroundColour, getMenuItemSize, getMenuItemAlignment } from './Menu.styles.helper.js';
import { getTypographyStyles } from '../Typography/Typography.styles.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var Container = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  /* The border is always the same colour, regardless of the variant */\n  border: ", ";\n  max-width: fit-content;\n  box-shadow: ", ";\n  ", ";\n"])), getMenuBackgroundColour, function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.colours.canvas.primary.main, " ").concat(theme.sizing.xxtiny, " solid");
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.effects.dropShadow.regular;
}, applyPositioning);
var MenuItemContainer = styled.li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: ", ";\n  opacity: ", ";\n  background-color: ", ";\n  display: flex;\n  position: relative;\n  color: ", ";\n  border-left: ", " solid;\n  border-color: ", ";\n  border-bottom: ", ";\n\n  &:hover {\n    ", "\n  }\n\n  &:has(> ul:hover) {\n    background-color: ", ";\n  }\n"])), function (_ref3) {
  var $isDisabled = _ref3.$isDisabled;
  return $isDisabled ? 'not-allowed' : 'pointer';
}, getMenuOpacity, getMenuItemBackgroundColour, getMenuItemTextColour, function (_ref4) {
  var theme = _ref4.theme;
  return theme.sizing.tiny;
}, function (_ref5) {
  var $isActive = _ref5.$isActive,
    theme = _ref5.theme;
  return $isActive ? theme.colours["interface"].main : 'transparent';
}, function (_ref6) {
  var $isTitle = _ref6.$isTitle,
    $isActive = _ref6.$isActive,
    theme = _ref6.theme;
  return !$isActive && $isTitle && "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main);
}, function (_ref7) {
  var $isDisabled = _ref7.$isDisabled,
    theme = _ref7.theme,
    $variant = _ref7.$variant;
  return !$isDisabled && "background-color: ".concat(getThemeValueByKey({
    findKey: SURFACE_COLOUR_VARIANTS[$variant].hoverBackground,
    tokens: theme
  }), ";\n      opacity: 1;\n      ");
}, function (_ref8) {
  var theme = _ref8.theme,
    $variant = _ref8.$variant;
  return getThemeValueByKey({
    findKey: SURFACE_COLOUR_VARIANTS[$variant].selectedBackground,
    tokens: theme
  });
});
var MenuItemContent = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  background-color: ", ";\n  display: flex;\n  margin-left: -", ";\n  ", "\n  ", "\n"])), function (_ref9) {
  var $isActive = _ref9.$isActive;
  return $isActive ? getActiveOverlayBackgroundColour : 'transparent';
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.sizing.tiny;
}, getMenuItemSize, getMenuItemAlignment);
var SubMenuContainer = styled(Container)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 12.5rem;\n  top: -", ";\n  display: none;\n\n  ", ":hover & {\n    display: block;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.sizing.tiny;
}, MenuItemContainer);
var MenuItemTitle = styled(getTypographyStyles('headingMedium'))(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: inherit;\n"])));
var MenuItemContentGroup = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.sizing.tiny;
});

export { Container, MenuItemContainer, MenuItemContent, MenuItemContentGroup, MenuItemTitle, SubMenuContainer };
//# sourceMappingURL=Menu.styles.js.map
